import { render, staticRenderFns } from "./AdvanceCommission.vue?vue&type=template&id=b0b9d814&scoped=true"
import script from "./AdvanceCommission.vue?vue&type=script&lang=js"
export * from "./AdvanceCommission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b9d814",
  null
  
)

export default component.exports